"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUsername = exports.StyledLink = exports.StaticChipContainer = exports.DismissButton = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _button = require("../../button");

var _context = require("../../context");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _link = require("../../link");

var _text = require("../../text");

var _utils = require("../../utils");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _constants2 = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StaticChipContainer = (0, _context.styledWithTheme)(_layout.Row, {
  shouldForwardProp: (0, _utils.filterProps)(['backgroundColor', 'colorScheme', 'size'])
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      colorScheme = _ref.colorScheme,
      hasAvatar = _ref.hasAvatar,
      size = _ref.size,
      isDismissible = _ref.isDismissible,
      selectors = _ref.theme.selectors;
  var isExtraSmall = size === _interfaces.ChipSize.ExtraSmall;
  var startPadding = selectors.space(_constants2.PADDING_STATIC_HORIZONTAL[size]);

  if (hasAvatar) {
    if (isExtraSmall) startPadding = 0;else startPadding = selectors.space(_constants2.PADDING_AVATAR_START);
  }

  var endPadding = selectors.space(hasAvatar ? _constants2.PADDING_AVATAR_END : _constants2.PADDING_STATIC_HORIZONTAL[size]);

  if (isDismissible) {
    // Count right padding from the side of the icon, not from the side
    // of the button, so visually the padding is consistent on both sides
    endPadding = endPadding - (_constants2.DISMISS_BUTTON_VISIBLE_SIZE[size] - _icons.IconSize.ExtraSmall) / 2;
  }

  return {
    alignItems: 'center',
    backgroundColor: selectors.color(_constants2.BACKGROUND_COLOR[colorScheme][backgroundColor]),
    borderRadius: selectors.radius('R100'),
    color: selectors.color(_constants2.FOREGROUND_COLOR[colorScheme]),
    gridGap: (0, _utils.px)(selectors.space(_constants.CHIP_CONTENT_GAP)),
    height: _constants.CONTAINER_HEIGHTS[size],
    maxWidth: '100%',
    padding: "0 ".concat((0, _utils.px)(endPadding), " 0 ").concat((0, _utils.px)(startPadding)),
    width: 'max-content'
  };
});
exports.StaticChipContainer = StaticChipContainer;
var StyledUsername = (0, _context.styledWithTheme)(_text.Text, {
  shouldForwardProp: (0, _utils.filterProps)(['colorScheme'])
})(function (_ref2) {
  var colorScheme = _ref2.colorScheme,
      selectors = _ref2.theme.selectors;
  return {
    color: selectors.color(_constants2.AVATAR_USERNAME_TEXT_COLOR[colorScheme])
  };
});
exports.StyledUsername = StyledUsername;
var StyledLink = (0, _context.styledWithTheme)(_link.Link)(function (_ref3) {
  var colorScheme = _ref3.colorScheme,
      selectors = _ref3.theme.selectors;
  return {
    color: selectors.color(_constants2.AVATAR_USERNAME_LINK_COLOR[colorScheme]),
    fontWeight: selectors.fontWeight('regular'),
    textDecoration: 'underline'
  };
});
exports.StyledLink = StyledLink;
var DismissButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref4) {
  var colorScheme = _ref4.colorScheme,
      backgroundColor = _ref4.backgroundColor,
      chipSize = _ref4.chipSize,
      selectors = _ref4.theme.selectors;
  var isExtraSmall = chipSize === _interfaces.ChipSize.ExtraSmall;
  var buttonSize = _constants2.DISMISS_BUTTON_VISIBLE_SIZE[chipSize];
  return _objectSpread({
    border: 'none',
    minWidth: 0,
    minHeight: 0,
    height: buttonSize,
    width: buttonSize,
    padding: 0,
    borderRadius: selectors.radius('R100'),
    ':hover': {
      backgroundColor: selectors.color(_constants2.DISMISS_HOVER_BACKGROUND_COLOR[colorScheme][backgroundColor])
    },
    ':active': {
      backgroundColor: selectors.color(_constants2.DISMISS_ACTIVE_BACKGROUND_COLOR[colorScheme][backgroundColor])
    },
    ':focus': {
      outlineColor: 'transparent'
    },
    ':focus-visible': {
      outlineColor: selectors.color(_constants2.DISMISS_OUTLINE_COLOR[colorScheme])
    }
  }, isExtraSmall ? {
    ':after': {
      content: '""',
      position: 'absolute',
      width: 24,
      height: 24,
      left: -4,
      top: -4
    }
  } : {});
});
exports.DismissButton = DismissButton;